// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".push-menu-layer .nav-justified {\n  padding: 10px;\n}\n.push-menu-layer .vertical-timeline-element-content p {\n  font-size: 1.1em !important;\n}\n.push-menu-layer .vertical-timeline-element-content .timeline-title {\n  font-size: 1.25em !important;\n}\n.push-menu-layer .deletePush {\n  width: 40px;\n  height: 40px;\n  margin: 0 auto;\n  float: right;\n  padding-right: 7px;\n}\n.push-menu-layer .deletePush i {\n  font-size: 1.2em;\n  color: red;\n  font-weight: 600;\n}", ""]);
// Exports
module.exports = exports;
